import { useState, useEffect } from 'react';

const WordGuess = ({wordValidator, wordSubmission, onIndexChanged}) => {
    let wordLength = 5;
    const [currentTargetIndex, setCurrentTargetIndex] = useState(0);

    const [currentGuess, setCurrentGuess] = useState(() => 
        Array.from({ length: wordLength }, () => '')
    );

    const [guessIsValid, setGuessIsValid] = useState(true);

    const letterMatch = /^[a-zA-Z]$/

    const keyPressed = (key) => {
        if(key === "Backspace"){
            if(currentTargetIndex === 0){
                return;
            }
            setCurrentGuess((guess) => {
                let lastIndex = currentTargetIndex - 1;
                let lastGuess = guess.map((letter, letterIndex) => letterIndex === lastIndex ? '' : letter);
                updateIndex(lastIndex);
                setGuessIsValid(true);
                return lastGuess;
            });
            return;
        }
        
        if(key === "Enter"){  
            
            if (currentTargetIndex >= wordLength){
                if(guessIsValid){
                    var finalGuess = currentGuess.join('');
                    wordSubmission(finalGuess);
                }
            }

            setCurrentGuess((previousGuess) => previousGuess = previousGuess.map((_) => ''));  
            updateIndex(0);   
            setGuessIsValid(true);
            return;    
        }
        
        if (currentTargetIndex >= wordLength){
            return;
        }

        const validLetter = letterMatch.exec(key);
        if(!validLetter){
            return;
        }
        setCurrentGuess((previousGuess) => {
            var nextGuess = previousGuess.map((letter, letterIndex) => letterIndex === currentTargetIndex ? validLetter : letter);
            var nextTargetIndex = currentTargetIndex + 1;

            if (nextTargetIndex >= wordLength){   
                var finalGuess = nextGuess.join('');
                if(wordValidator(finalGuess)){
                    setGuessIsValid(true);
                } else{
                    setGuessIsValid(false);
                }
            }

            updateIndex(nextTargetIndex);
            return nextGuess;
        });
    }

    const  updateIndex = (index) => {
        setCurrentTargetIndex(index);
        onIndexChanged(index);
    }

    const onKeyUp = (event) => {
        keyPressed(event.key);
    }

    useEffect(() => { 
        window.addEventListener('keyup', onKeyUp);
        return () => {
            window.removeEventListener("keyup", onKeyUp);
          };
    }, [currentGuess]);

    return (
        <div className='word'>
            {currentGuess.map((letter, i) => (
                <div className='letterBox' type='input' state={!guessIsValid ? 'invalid' : letter !== '' ? 'valid' : 'incomplete'} key={`letter-${i}`}>
                    <span className='letter'>{letter}</span>
                </div>
            ))}         
        </div>
    )
}


export default WordGuess;